import { render, staticRenderFns } from "./skill-form.vue?vue&type=template&id=2878bf28&scoped=true&"
import script from "./skill-form.vue?vue&type=script&lang=js&"
export * from "./skill-form.vue?vue&type=script&lang=js&"
import style0 from "./skill-form.vue?vue&type=style&index=0&id=2878bf28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878bf28",
  null
  
)

export default component.exports